import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CardModule } from '../../notes/card/card.module';
import { IconModule } from '../../notes/icon/icon.module';

import { SpinnerModule } from '../../notes/spinner/spinner.module';
import { OverviewCardComponent } from './overview-card.component';
import { provideHttpClient } from '@angular/common/http';

@NgModule({
  declarations: [OverviewCardComponent],
  imports: [CommonModule, CardModule, IconModule, SpinnerModule],
  exports: [OverviewCardComponent],
  providers: [provideHttpClient()],
})
export class OverviewCardModule {}
